import { Inbox, Star, Send, File, Archive, ShieldAlert, Trash2, Folder, Calendar, Users, Settings, MessagesSquare, type LucideIcon } from "lucide-react";
import type { Mailbox } from "@dfws/contracts";

export const ROLE_ICON: Record<Mailbox["role"], LucideIcon> = {
  inbox: Inbox, flagged: Star, drafts: File, sent: Send, archive: Archive, junk: ShieldAlert, trash: Trash2, other: Folder,
};

const ROLE_LABEL: Partial<Record<Mailbox["role"], string>> = { inbox: "Inbox", flagged: "Starred", drafts: "Drafts", sent: "Sent", archive: "Archive", junk: "Spam", trash: "Trash" };

/** URL segment for a folder: the role for standard folders ("inbox"), "f<id>" for the user's own folders. */
export function folderSlug(m: Mailbox): string {
  return m.role === "other" ? `f${m.id}` : m.role;
}

export function folderLabel(m: Mailbox): string {
  return ROLE_LABEL[m.role] ?? m.name;
}

export function findFolder(list: Mailbox[] | undefined, slug: string): Mailbox | undefined {
  if (!list) return undefined;
  return slug.startsWith("f") && /^f\d+$/.test(slug) ? list.find((m) => m.id === Number(slug.slice(1))) : list.find((m) => m.role === slug);
}

/** Go-to targets that always exist, for the palette and shortcuts. */
export const STANDARD_FOLDERS = [
  { slug: "inbox", label: "Inbox", icon: Inbox },
  { slug: "sent", label: "Sent", icon: Send },
  { slug: "drafts", label: "Drafts", icon: File },
  { slug: "archive", label: "Archive", icon: Archive },
] as const;

export const LABELS = [
  { id: "clients", label: "Clients", hue: 1 },
  { id: "finance", label: "Finance", hue: 3 },
];

/** Top-level apps other than Mail (Mail links need a folder param). */
export const OTHER_APPS = [
  { to: "/chat", label: "Chat", icon: MessagesSquare },
  { to: "/calendar", label: "Calendar", icon: Calendar },
  { to: "/contacts", label: "Contacts", icon: Users },
  { to: "/settings", label: "Settings", icon: Settings },
] as const;

export const MAIL_APP = { label: "Mail", icon: Inbox } as const;
